import { render, staticRenderFns } from "./MergeDialog.vue?vue&type=template&id=70d8b013"
import script from "./MergeDialog.vue?vue&type=script&lang=js"
export * from "./MergeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports